module.exports = __webpack_public_path__ + "img/telegram.500a6d96.svg";